import axios from './authService';
import { API_ENDPOINTS } from '../config/apiConfig';
import store from '../redux/store';
import { getStoredAppiumUrl, getStoredAdbRunnerUrl } from './appiumService';
import { getDeviceIdForAppiumScripts } from '../utilities/getDevideIdForAppiumScripts';

function getRunConfig() {
  const state = store.getState();
  const selectedDevice = state.platform.selectedDevice;
  return {
    platform: selectedDevice?.type,
    appium_url: state.platform.appiumUrl || undefined,
    adb_runner_url: state.platform.adbRunnerUrl || undefined,
    version: state.platform.selectedAppBuild || undefined,
    selectedDevice,
    market_id: state.config.market?.id,
  };
}

export async function fetchAppFlows(marketId) {
  const res = await axios.get(API_ENDPOINTS.GET_APP_FLOWS(marketId));
  return res.data;
}

export async function runScenario(flowId, scenarioId) {
  const { platform, appium_url, adb_runner_url, version, selectedDevice, market_id } =
    getRunConfig();

  const deviceId = getDeviceIdForAppiumScripts(selectedDevice);
  const res = await axios.post(API_ENDPOINTS.RUN_SCENARIO, {
    flowId,
    scenarioId,
    deviceId,
    platform,
    market_id,
    appium_url: appium_url || getStoredAppiumUrl() || undefined,
    adb_runner_url: adb_runner_url || getStoredAdbRunnerUrl() || undefined,
    version,
  });
  return res.data;
}

export async function rerunScenario(run) {
  const { appium_url, adb_runner_url, market_id } = getRunConfig();
  const res = await axios.post(API_ENDPOINTS.RUN_SCENARIO, {
    flowId: run.flowId,
    scenarioId: run.scenarioId,
    deviceId: run.deviceId,
    platform: run.platform,
    market_id: run.marketId || market_id,
    appium_url: appium_url || getStoredAppiumUrl() || undefined,
    adb_runner_url: adb_runner_url || getStoredAdbRunnerUrl() || undefined,
    version: run.version || undefined,
  });
  return res.data;
}

export async function runMultipleScenarios(items) {
  const { platform, appium_url, adb_runner_url, version, selectedDevice, market_id } =
    getRunConfig();
  const deviceId = getDeviceIdForAppiumScripts(selectedDevice);

  const payload = {
    items: items.map((item) => ({
      flowId: item.flowId,
      scenarioId: item.scenarioId,
      deviceId,
      platform,
      market_id,
      appium_url: item.appium_url || appium_url || getStoredAppiumUrl() || undefined,
      adb_runner_url: adb_runner_url || getStoredAdbRunnerUrl() || undefined,
      version,
    })),
  };
  const res = await axios.post(API_ENDPOINTS.RUN_MULTIPLE_SCENARIOS, payload);
  return res.data;
}
